export const GET_REPORT_FOR_DUTY_LOGS_REQUEST = "GET_REPORT_FOR_DUTY_LOGS_REQUEST";
export const GET_REPORT_FOR_DUTY_LOGS_SUCCESS = "GET_REPORT_FOR_DUTY_LOGS_SUCCESS";
export const GET_REPORT_FOR_DUTY_LOGS_FAILURE = "GET_REPORT_FOR_DUTY_LOGS_FAILURE";
